import React from "react";
import { PrimaryButton } from "./OnboardingFields";

function CompleteStep({ onContinue }) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <div className="w-full max-w-md">
        <h2 className="font-logo text-3xl sm:text-4xl text-black mb-4 leading-tight text-left">
          Ton espace personnel est prêt.
        </h2>
        <p className="font-josefin text-secondaryText text-sm sm:text-base text-left">
          Tu peux maintenant écrire ta première lettre.
        </p>

        <div className="mt-10 sm:mt-12 flex justify-end pb-4">
          <PrimaryButton
            variant="purple"
            onClick={onContinue}
            className="w-full sm:w-auto"
          >
            Accéder à mon espace
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default CompleteStep;
